import { put, select, call } from 'redux-saga/effects';
import request from 'superagent';
import ActionTypes from '../action.types';

export function* loadData(action) {
  if (action.payload.pathname !== '/dashboard') {
    return null;
  }

  yield put({ type: ActionTypes.CUSTOMERS_LIST_REQUESTED });

  const token = yield select(getToken);
  const timeRange = yield select(getTimeRange);
  const response = yield call(requestData, token, timeRange);

  if(response.error) {
    yield put({type: ActionTypes.ERROR, error: `${response.status} : ${response.statusText}`})
  }
  else yield put({ type: ActionTypes.CUSTOMERS_LIST_DONE, ...response });
}

export function getToken(state) {
  return state.auth.token;
}

export function getTimeRange(state) {
  return state.dashboard.meta.timeRange;
}

export function requestData(token, timeRange) {
  return request
    .get('/api/data')
    .query(parseTimeRange(timeRange))
    .set('Bearer', token)
    .then(res => res.body)
    .catch(error => error.response);
}

function parseDate(date) {
  return date.format('YYYY-MM-DD');
}

function parseTimeRange(timeRange) {
  return { from: parseDate(timeRange.from), to: parseDate(timeRange.to) };
}



// WEBPACK FOOTER //
// ./src/Dashboard/saga.js